export default function authHeader() {
    return { withCredentials: true };
}